import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { BROADCAST_VIEW_DIALOG_TEST_ID } from './BroadcastViewDetailDialog';

export const InProgressAlert = (): JSX.Element => {
	return (
		<InlineAlertWidget
			children={<span data-tb-test-id={BROADCAST_VIEW_DIALOG_TEST_ID + '-alert-msg'} >{Messages.broadcastInProgressInfo()}</span>}
			type={InlineAlertType.Info}
			testId={`${BROADCAST_VIEW_DIALOG_TEST_ID}-inline-alert`}
		/>
	);
};